<template>
  <div>
    <div :class="stepClass">
      <div class="columns">

        <div class="column is-half-desktop is-full-tablet">
          <input-custom
            id="first-name"
            key="firstName"
            v-model.lazy="$v.value.firstName.$model"
            stop-clearfix
            :input-class="`${hasErrorClass($v.value.firstName)}`"
            type="text"
            :label="this.$t('common.firstname')"
            :error-text="errorGenerator($v.value.firstName)"
          />
        </div>

        <div class="column is-half-desktop is-full-tablet">
          <input-custom
            id="last-name"
            key="lastName"
            v-model.lazy="$v.value.lastName.$model"
            stop-clearfix
            :input-class="`${hasErrorClass($v.value.lastName)}`"
            type="text"
            :label="this.$t('common.lastname')"
            :error-text="errorGenerator($v.value.lastName)"
            @input="delayTouch($v.value.lastName)"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-custom
            id="business-name"
            key="businessName"
            v-model.lazy="$v.value.businessName.$model"
            stop-clearfix
            :input-class="`${hasErrorClass($v.value.businessName)}`"
            type="text"
            :label="this.$t('business_listing.stepper.business_name')"
            :error-text="errorGenerator($v.value.businessName)"
            @input="delayTouch($v.value.businessName)"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
            <textarea-custom
              id="business-description"
              key="businessDescription"
              stop-clearfix
              v-model.lazy="$v.value.businessDescription.$model"
              type="textarea"
              :label="this.$t('business_listing.stepper.description')"
              :input-class="`${hasErrorClass($v.value.businessDescription)}`"
              :error-text="errorGenerator($v.value.businessDescription)"
              @input="delayTouch($v.value.businessDescription)"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputCustom from '@/components/Shared/Form/InputCustom'
import TextareaCustom from '@/components/Shared/Form/TextAreaCustom'

import formHelperMixin from '@/mixins/form-helper'
import { helpers } from 'vuelidate/lib/validators'

const minLenghtOptional = (limit) => helpers.withParams(
  { type: 'minLenghtOptional', min: limit },
  (value) => {
    if (value.length === 0) {
      return true
    }

    if (value.length > limit) {
      return true
    }
    return false
  })

export default {

  name: 'StepBusiness',
  components: {
    // CustomInput,
    InputCustom,
    TextareaCustom
  },
  mixins: [formHelperMixin],
  props: {
    // class can't be used as a prop name, so to pass any custom classes as a
    // prop, we need to pass them in as 'stepClass'
    stepClass: {
      type: String,
      default: ''
    },
    // Check if this step is the first or last and therefore decide whether to
    // show or hide the next/prev buttons
    isOuterStep: {
      type: Object,
      default: () => ({ first: true, last: false })
    },
    // The value should be passed in as a prop, and we can use the v-model
    // directive to bind to the specific part of the passed value relevant
    // for this step
    value: {
      type: Object,
      default: () => ({
        firstName: '',
        lastName: '',
        businessName: '',
        businessDescription: ''
      })
    }
  },
  validations: {
    value: {
      firstName: {
        minLenghtOptional: minLenghtOptional(2)
      },
      lastName: {
        minLenghtOptional: minLenghtOptional(2)
      },
      businessName: {
        minLenghtOptional: minLenghtOptional(2)
      },
      businessDescription: {
        minLenghtOptional: minLenghtOptional(2)
      }
    }
  },
  watch: {
    $v: {
      handler (obj) {
        this.value.hasError = this.$v.value.$anyError
      },
      deep: true
    }
  },
  methods: {
    step ({ target }) {
      if (target.id === 'next-btn') {
        this.$emit('next', this.$v)
      } else if (target.id === 'prev-btn') {
        this.$emit('prev')
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
